import ButtonIcon from "@mui/icons-material/Add"
import { Button } from "@mui/material"
import React from "react"
import { ButtonProps, Link, useRecordContext } from "react-admin"

export const AddPropertyButton: React.FC<ButtonProps> = (props) => {
  const record = useRecordContext(props)

  return (
    <Button
      title="Add Property"
      color="primary"
      component={Link}
      to={{
        pathname: "/rental/listed_properties/create",
      }}
      state={{ record: { provider_account_id: record.id } }}
    >
      <ButtonIcon /> Add Property
    </Button>
  )
}
